//@flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';


const RoundDeviderWrapper = styled.div`
	padding-top: 1em;
	padding-bottom: 1em;
	h2{
		width: 100%; 
		text-align: center; 
		border-bottom: 1px solid ${colors.form_border}; 
		line-height: 0.1em;
		margin: 10px 0 20px;
		color:  ${colors.form_border};
		> span {
			text-transform: uppercase;
			background:#fff; 
			padding:0 10px; 
		} 
	}
`;

type Props = {
	round_number: number,
}

export const RoundDevider = ({ round_number }: Props) => (
	<RoundDeviderWrapper>
		<h2>
			<span>
				Round { round_number }
			</span>
		</h2>
	</RoundDeviderWrapper>

);
RoundDevider.defaultProps = {
	round_number: 1
};
export default RoundDevider;


// WEBPACK FOOTER //
// ./src/components/DraftOrderWidget/RoundDevider.js